import { createContext, useCallback, useContext, useState } from "react";
import QuoteModal from "@/components/QuoteModal";

const QuoteContext = createContext({ openQuoteModal: () => {}, closeQuoteModal: () => {} });

export const useQuote = () => useContext(QuoteContext);

export function QuoteProvider({ children }) {
  const [open, setOpen] = useState(false);
  const [presetProduct, setPresetProduct] = useState("");

  const openQuoteModal = useCallback((product = "") => {
    setPresetProduct(product);
    setOpen(true);
  }, []);
  const closeQuoteModal = useCallback(() => setOpen(false), []);

  return (
    <QuoteContext.Provider value={{ openQuoteModal, closeQuoteModal }}>
      {children}
      {open && <QuoteModal presetProduct={presetProduct} onClose={closeQuoteModal} />}
    </QuoteContext.Provider>
  );
}

export default QuoteProvider;
